/* Airah Luxury Design System — scroll reveal.
   Content is fully visible without JS; reveal states activate only once
   .lx-js is present, so nothing can be hidden if this file fails to load. */
(function () {
  document.documentElement.classList.add('lx-js');

  var reveal = function () {
    var items = document.querySelectorAll('.lx-reveal:not(.lx-inview)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('lx-inview'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lx-inview');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { observer.observe(el); });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal);
  } else {
    reveal();
  }
  document.addEventListener('shopify:section:load', reveal);
})();

/* The former "bed options early reveal" block was retired on 2026-09-17. It
   forced three named option groups visible with inline !important styles. That
   job is now done properly, and for every option group, by
   airah-configurator.js / .css — which arranges the options app's own elements
   into numbered sections and leaves the app in charge of what may be chosen. */
